import SectionMixin from '@/mixins/sectionMixin'
import LuloProForm from "@/components/forms/lulo-pro-form"


export default {
    name: 'feature-splited-form-block',
    mixins: [SectionMixin],
    components: {
        "lulo-pro-form": LuloProForm,
    },
    props: {
        number: String,
        imgUrl: String,
        description: String,
        title: String,
        disclaimer: String,
    },
    data: () => {
        return {
            isIntersecting: false,
            visible: false,
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        show() {
            if (this.visible) {
                return
            }
            this.visible = true
            this.$refs["form"].visible = true
        },
    }
}